export default __webpack_public_path__ + "static/media/services-illustration.8a741a05.png";